import * as React from 'react';
import PropTypes from 'prop-types';

const SvgSportsHandcycleNormalXsmall = React.forwardRef(
  ({ color, size, title, titleId, ...props }, ref) => (
    <svg
      fill={color}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 16 16"
      ref={ref}
      width={size}
      height={size}
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <path
        d="M2.51 6.5a2 2 0 100 4 2 2 0 000-4zm0 3a1 1 0 110-2 1 1 0 010 2zM7 9.5h3.56l.627-1.076.284.151a2.03 2.03 0 10.229-1.013L9.13 6.2a.878.878 0 00-1.688-.254.885.885 0 001.21 1.132l1.655.878-.317.544H7a.593.593 0 01-.51-.3L5.07 5.5H3.94l1.67 3.16A1.566 1.566 0 007 9.5zm6.49-2.03a1.015 1.015 0 11-1.02 1.02 1.022 1.022 0 011.02-1.02zM8.14 6.28a.12.12 0 01.12-.11.111.111 0 01.11.11c0 .13-.23.13-.23 0z"
        fill=""
      />
    </svg>
  )
);
SvgSportsHandcycleNormalXsmall.defaultProps = {
  color: 'currentColor',
  size: 16,
  title: undefined,
  titleId: undefined
};
SvgSportsHandcycleNormalXsmall.propTypes = {
  color: PropTypes.string,
  size: PropTypes.number,
  title: PropTypes.string,
  titleId: PropTypes.string
};
export default SvgSportsHandcycleNormalXsmall;
